import React from 'react';

export default function PetPickerFooter() {
	return (
		<div className="pet-picker__footer">
			<div className="pet-picker__footer__item">
				All prices are listed in USD ($).
			</div>
			<a
				className="pet-picker__footer__item pet-picker__footer__item--link"
				href="https://tabbycats.club/faq"
				target="_blank"
				rel="noopener noreferrer">
				Frequently Asked Questions
			</a>
		</div>
	);
}



// WEBPACK FOOTER //
// ./src/components/Extension/PetPicker/PetPickerFooter.js